import { Button } from '@mui/material';
import styled from 'styled-components';

import { COLORS } from '../../../../theme';

export const StyledButton = styled(Button)`
  &.MuiButton-root {
    font-size: ${({ theme }) => theme.fontSize.body2};
    font-weight: ${({ theme }) => theme.fontWeight.medium};
    font-style: normal;
    display: inline-flex;
    padding: ${({ theme }) => theme.spacing.s2}
      ${({ theme }) => theme.spacing.s2};
    justify-content: center;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.s2};
    letter-spacing: 0.032px;

    /* Semantic Border Radius */
    border-radius: var(--radius-md);

    /* Semantic Font Family */
    font-family: var(--font-family-primary);
  }

  &.MuiButton-contained {
    background-color: var(--btn-secondary-bg);
    color: var(--btn-secondary-text);
    path {
      fill: var(--btn-secondary-text);
    }
  }

  /* Exclude the error variant so danger buttons never pick up the
     secondary (brand) hover/pressed background. */
  &.MuiButton-contained:not(.MuiButton-containedError):hover {
    background-color: var(--btn-secondary-bg-hover);
  }

  &.MuiButton-contained:not(.MuiButton-containedError):active {
    background-color: var(--btn-secondary-bg-active);
  }

  &.MuiButton-containedError {
    background-color: ${({ theme }) => theme.buttonBg.muiError};
    color: var(--text-inverse);
    path {
      fill: var(--text-inverse);
    }
    &:hover {
      background-color: ${COLORS.redDark};
    }
    &:active {
      background-color: ${COLORS.redDark};
    }
  }

  &.MuiButton-root.Mui-disabled {
    background-color: var(--border-color);
    color: var(--text-disabled) !important;
    path {
      fill: var(--text-disabled);
    }
  }

  & .MuiButton-startIcon {
    .smallIcon {
      font-size: inherit;
    }
  }
`;
